var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group"},[_c('div',{staticClass:"label"},[_vm._v("\n    "+_vm._s(_vm.$l.popupQuizPointName)+"\n  ")]),_c('div',[_vm._v("\n    "+_vm._s(_vm.quiz.get('name'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }